import { Component, OnInit, ViewChild } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ControlPermission } from '@pages/modules-permission/interfaces/controlPermission';
import { ControlFormPermissionComponent } from './control-form-permission/control-form-permission.component';
import { SwalService } from '@shared/utils/swal.service';
import { FormsService } from '@pages/modules-permission/services/forms.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { FormPermission } from '@pages/modules-permission/interfaces/FormPermission';

@Component({
  selector: 'app-form-permission',
  templateUrl: './form-permission.component.html',
  styleUrls: ['./form-permission.component.css'],
})
export class FormPermissionComponent implements OnInit {
  private readonly _width: string = '1000px';
  public allData: number = 0;
  public loading: boolean = true;
  id: number = 0;
  displayedColumns: string[] = [
    'actions',
    'permissionFormId',
    'formName',
    'description',
    'enable',
    'userCreator',
    'create',
    'read',
    'update',
    'delete',
  ];
  dataSource = new MatTableDataSource();
  constructor(
    public _dialog: MatDialog,
    private _swalService: SwalService,
    private _formService: FormsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}
  @ViewChild(MatPaginator) paginator: MatPaginator;
  

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;    
    this.read();
    this.loadControls();   
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  read() {
    this._formService.read().subscribe((res) => {
      this.dataSource.data = res.data;
      console.log(res);
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

  loadControls() {
    this._formService.readControls().subscribe((res) => {
      sessionStorage.setItem('Forms', JSON.stringify(res['data']));
    });
  }

  openCreate() {
    const dialogRef = this._dialog.open(ControlFormPermissionComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  openControles(model: ControlPermission) {
    this.router.navigate(['Admin/control', model.formId])
  }

  openUpdate(model: ControlPermission) {
    const dialogRef = this._dialog.open(ControlFormPermissionComponent, {
      width: this._width,
      data: model,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  delete(model: FormPermission) {
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._formService.delete(model).subscribe((res) => {
          if (res.exito === 1) this._swalService.success('Eliminado');
          else this._swalService.error('No Eliminado');
          this.read();
        });
      }
    });
  }
}
